import allCareApi from './allCareApi';

export default async function postReorder(requestId: string) {
  await allCareApi.post(`/report-requests/${requestId}/reorder`);
}
